/**
 * Эта функция важна для удобства
 * создания мока на стор в тестах
 */
export const useStore = () => {};
